<template>
    <div>
        <div class="d-flex align-center mb-1">
            <v-text-field
                v-model.trim="search_query"
                label="Szukaj"
                prepend-inner-icon="mdi-magnify"
                clearable
            ></v-text-field>

            <v-spacer></v-spacer>

            <span class="body-2 text--secondary d-none d-sm-inline">{{ from }}-{{ to }} z {{ total }}</span>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" :disabled="is_page_first" @click="prev_page">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                </template>
                <span>Poprzednia strona</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" :disabled="is_page_last" @click="next_page">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </template>
                <span>Następna strona</span>
            </v-tooltip>
        </div>

        <loading-message v-if="clientIndexing" :message="loading_message" class="my-5"></loading-message>
        <v-simple-table v-else-if="clients.length">
            <template v-slot:default>
                <tbody>
                <tr
                    v-for="client in clients"
                    :key="client.ClientID"
                >
                    <th class="text-no-wrap">{{ client.ClientName }}</th>
                    <td>
                        <div>{{ client.City.CityName }}, {{ client.Street }}</div>
                        <div class="font-weight-regular text-caption text--secondary">
                            Tel: {{ client.ClientDetail.Phone || '-' }}, Email: {{ client.ClientDetail.Email || '-' }}
                        </div>
                    </td>
                    <td>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-if="client.InvitedToWebAppAt"
                                    color="success"
                                    v-bind="attrs"
                                    v-on="on">mdi-send</v-icon>
                                <v-icon v-else v-bind="attrs" v-on="on">mdi-send-outline</v-icon>
                            </template>
                            <span v-if="client.InvitedToWebAppAt">Wysłano zaproszenie</span>
                            <span v-else>Nie wysłano zaproszenia</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-if="client.WebAppUser"
                                    color="success"
                                    v-bind="attrs"
                                    v-on="on">mdi-account</v-icon>
                                <v-icon v-else v-bind="attrs" v-on="on">mdi-account-outline</v-icon>
                            </template>
                            <span v-if="client.WebAppUser">Klient założył konto</span>
                            <span v-else>Klient nie założył konta</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-if="client.WebAppUser && client.WebAppUser.hasVerifiedEmail"
                                    color="success"
                                    v-bind="attrs"
                                    v-on="on">
                                    mdi-check-circle
                                </v-icon>
                                <v-icon v-else v-bind="attrs" v-on="on">mdi-check-circle-outline</v-icon>
                            </template>
                            <span v-if="client.WebAppUser && client.WebAppUser.hasVerifiedEmail">
                                Klient potwierdził adres email
                            </span>
                            <span v-else>Klient nie potwierdził adresu email</span>
                        </v-tooltip>
                    </td>
                    <td>
                        <div>Kod klienta: {{ client.WebAppCode }}</div>
                        <div v-if="client.WebAppUser">login: {{ client.WebAppUser.email }}</div>
                    </td>
                    <td class="text-right">
                        <v-menu
                            bottom
                            left
                            :offset-y="true"
                            rounded
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>

                            <v-list dense>
                                <v-list-item>
                                    <v-list-item-title>
                                        <a @click="showClientInviteDialog(client)"><v-icon small>mdi-send-outline</v-icon>
                                            {{
                                                client.InvitedToWebAppAt
                                                ? 'Ponownie zaproś do systemu'
                                                : 'Zaproś do systemu'
                                            }}
                                        </a>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="client.WebAppUser && !client.WebAppUser.hasVerifiedEmail">
                                    <v-list-item-title>
                                        <a
                                            @click="showWebAppUserEmailVerificationAtDialog(client.WebAppUser)"
                                        >
                                            <v-icon small>mdi-check-circle-outline</v-icon>
                                            Aktywuj konto
                                        </a>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="client.WebAppUser">
                                    <v-list-item-title>
                                        <a @click="showWebAppUserEmailUpdateDialog(client.WebAppUser)">
                                            <v-icon small>mdi-account-outline</v-icon> Zmień login (email)
                                        </a>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="client.WebAppUser">
                                    <v-list-item-title>
                                        <a @click="showWebAppUserDeleteDialog(client.WebAppUser)">
                                            <v-icon small>mdi-account-remove-outline</v-icon> Usuń konto web
                                        </a>
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-alert
            v-else
            border="left"
            colored-border
            type="info"
            elevation="1"
        >{{ empty_message }}</v-alert>

        <v-dialog
            v-if="clientToInvite"
            v-model="clientInviteDialog"
            persistent
            max-width="600px"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Zaproszenie klienta do aplikacji
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideClientInviteDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    Zaproś do systemu klienta <strong>{{ clientToInvite.ClientName }}</strong>.
                    Wprowadź adres email na który chcesz wysłać zaproszenie z kodem klienta.
                </v-card-text>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="clientInviteForm.email"
                                    label="Email"
                                    autofocus
                                    clearable
                                    :error="$store.getters.hasValidationError('email')"
                                    :error-messages="$store.getters.validationError('email')"
                                    maxlength="255"
                                    :counter="255"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="invitedClientStore(clientToInvite.ClientID)"
                        :loading="clientInviting"
                    >
                        Wyślij
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="webAppUserToUpdateEmail"
            v-model="webAppUserEmailUpdateDialog"
            persistent
            max-width="600px"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Edycja loginu użytkownika aplikacji web
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideWebAppUserEmailUpdateDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="webAppUserEmailUpdateForm.email"
                                    label="Email (login)"
                                    autofocus
                                    clearable
                                    :error="$store.getters.hasValidationError('email')"
                                    :error-messages="$store.getters.validationError('email')"
                                    maxlength="255"
                                    :counter="255"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="webAppUserEmailUpdate(webAppUserToUpdateEmail.id)"
                        :loading="webAppUserEmailUpdating"
                    >
                        Zapisz
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="webAppUserDeleteDialog"
            persistent
            width="500"
        >
            <v-card v-if="webAppUserToDelete">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Usuwanie konta web
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideWebAppUserDeleteDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    Czy na pewno chcesz usunąć konto web dla loginu
                    <strong class="text-no-wrap">{{webAppUserToDelete.email}}</strong>?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        rounded
                        @click="webAppUserDelete(webAppUserToDelete.id)"
                        :loading="webAppUserDeleting"
                    >Usuń</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="webAppUserToEmailVerificationAt"
            v-model="webAppUserEmailVerificationAtDialog"
            persistent
            max-width="600px"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Potwierdź adres email klienta
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideWebAppUserEmailVerificationAtDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    Czy chcesz aktywować konto <strong>{{webAppUserToEmailVerificationAt.email}}</strong>?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="webAppUserEmailVerifiedAtUpdate(webAppUserToEmailVerificationAt.id)"
                        :loading="webAppUserEmailVerificationAtUpdating"
                    >
                        Aktywuj
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoadingMessage from "../../../components/LoadingMessage";
export default {
    name: "Clients",
    components: {
        LoadingMessage,
    },
    data() {
        return {
            search_query: "",

            clientIndexing: false,

            clients: [],

            clientToInvite: null,
            clientInviteDialog: false,
            clientInviting: false,
            clientInviteForm: {
                email: null,
            },

            webAppUserToUpdateEmail: null,
            webAppUserEmailUpdateDialog: false,
            webAppUserEmailUpdating: false,
            webAppUserEmailUpdateForm: {
                email: null,
            },

            webAppUserToEmailVerificationAt: null,
            webAppUserEmailVerificationAtDialog: false,
            webAppUserEmailVerificationAtUpdating: false,

            webAppUserToDelete: null,
            webAppUserDeleteDialog: false,
            webAppUserDeleting: false,

            // pagination
            page: 1,
            last_page:1,
            from: 0,
            to: 0,
            total: 0,
        };
    },

    computed: {
        is_mobile() {
            return this.$vuetify.breakpoint.mobile;
        },

        is_page_first() {
            return this.page === 1;
        },

        is_page_last() {
            return this.page === this.last_page;
        },

        loading_message() {
            return ! this.search_query
                ? "Pobieranie listy klientów..."
                : "Wyszukiwanie klientów...";
        },

        empty_message() {
            return ! this.search_query
                ? "Brak klientów"
                : "Nie znaleziono klientów pasujących do podanej frazy";
        },

        clientToInviteEmail() {
            return this.clientToInvite
                ? this.clientToInvite.ClientDetail.Email
                : null;
        },

        webAppUserToUpdateEmailEmail() {
            return this.webAppUserToUpdateEmail
                ? this.webAppUserToUpdateEmail.email
                : null;
        },
    },

    methods: {
        next_page: function () {
            if (this.page < this.last_page) this.page++;
        },
        prev_page: function () {
            if (this.page > 1) this.page--;
        },
        clientIndex: function () {
            this.clientIndexing = true;

            this.$store.dispatch('clientIndex', {
                page: this.page,
                search_query: this.search_query
            }).then(response => {
                if(response.status === 200) {
                    this.clients = response.data.data;
                    this.page = response.data.meta.current_page ?? 1;
                    this.last_page = response.data.meta.last_page ?? 1;
                    this.from = response.data.meta.from ?? 0;
                    this.to = response.data.meta.to ?? 0;
                    this.total = response.data.meta.total;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy klientów.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.clientIndexing = false;
                });
        },
        invitedClientStore: function (ClientID) {
            this.clientInviting = true;

            this.$store.dispatch('invitedClientStore', {
                ClientID: ClientID,
                formData: this.clientInviteForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideClientInviteDialog();
                    this.$store.commit("showSnackbarSuccess", "Wysłano zaproszenie.");
                    this.clientIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Nie udało się wysłać zaproszenia. Spróbuj ponownie.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.clientInviting = false;
                });
        },
        webAppUserEmailUpdate: function (userId) {
            this.webAppUserEmailUpdating = true;

            this.$store.dispatch('webAppUserEmailUpdate', {
                userId: userId,
                formData: this.webAppUserEmailUpdateForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideWebAppUserEmailUpdateDialog();
                    this.$store.commit("showSnackbarSuccess", "Zaktualizowano login klienta.");
                    this.clientIndex();
                } else {
                    this.$store.commit(
                        "showSnackbarError",
                        "Nie udało się zmienić loginu klienta. Spróbuj ponownie."
                    );
                }
            })
                .catch(error => {})
                .then(() => {
                    this.webAppUserEmailUpdating = false;
                });
        },
        webAppUserDelete : function (userId) {
            this.webAppUserDeleting = true;

            this.$store.dispatch('webAppUserDelete', userId).then(response => {
                if (response.status === 204) {
                    this.hideWebAppUserDeleteDialog();
                    this.$store.commit("showSnackbarSuccess", "Usunięto konto web klienta.");
                    this.clientIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd usuwania konta web.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.webAppUserDeleting = false;
                });
        },
        webAppUserEmailVerifiedAtUpdate: function (userId) {
            this.webAppUserEmailVerificationAtUpdating = true;

            this.$store.dispatch('webAppUserEmailVerifiedAtUpdate', userId)
                .then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideWebAppUserEmailVerificationAtDialog();
                    this.$store.commit("showSnackbarSuccess", "Zweryfikowano email klienta.");
                    this.clientIndex();
                } else {
                    this.$store.commit(
                        "showSnackbarError",
                        "Nie udało się zweryfikować loginu klienta. Spróbuj ponownie."
                    );
                }
            })
                .catch(error => {})
                .then(() => {
                    this.webAppUserEmailVerificationAtUpdating = false;
                });
        },
        showClientInviteDialog: function (client) {
            this.clientToInvite = client;
        },
        hideClientInviteDialog: function () {
            this.clientInviteDialog = false;
            this.$store.commit("resetValidation");
        },
        showWebAppUserEmailUpdateDialog: function (webAppUser) {
            this.webAppUserToUpdateEmail = webAppUser;
        },
        hideWebAppUserEmailUpdateDialog: function () {
            this.webAppUserEmailUpdateDialog = false;
            this.$store.commit("resetValidation");
        },
        showWebAppUserDeleteDialog: function (webAppUser) {
            this.webAppUserToDelete = webAppUser;
        },
        hideWebAppUserDeleteDialog: function () {
            this.webAppUserDeleteDialog = false;
            this.$store.commit("resetValidation");
        },
        showWebAppUserEmailVerificationAtDialog: function(webAppUser) {
            this.webAppUserToEmailVerificationAt = webAppUser;
        },
        hideWebAppUserEmailVerificationAtDialog: function() {
            this.webAppUserToEmailVerificationAt = null;
            this.webAppUserEmailVerificationAtDialog = false;
        }
    },

    created() {
        this.debouncedClientIndex = _.debounce(this.clientIndex, 900);
        this.debouncedClientIndexFast = _.debounce(this.clientIndex, 300);

        this.clientIndex();
    },

    watch: {
        search_query: function (new_value, old_value) {
            //If any request_search is currently in progress, cancel it!
            if(this.$store.state.sources.client_index) {
                this.$store.state.sources.client_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedClientIndex();
        },
        page: function (new_value, old_value) {
            //If any request_search is currently in progress, cancel it!
            if(this.$store.state.sources.client_index) {
                this.$store.state.sources.client_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedClientIndexFast();
        },
        clientToInvite: function (client) {
            if(client !== null) {
                this.clientInviteDialog = true;
            }
        },
        clientInviteDialog: function (newValue) {
            if(!newValue) {
                this.clientToInvite = null;
            }
        },
        clientToInviteEmail: function (newValue) {
            this.clientInviteForm.email = newValue;
        },
        webAppUserToUpdateEmail: function (webAppUser) {
            if(webAppUser !== null) {
                this.webAppUserEmailUpdateDialog = true;
            }
        },
        webAppUserEmailUpdateDialog: function (newValue) {
            if(!newValue) {
                this.webAppUserToUpdateEmail = null;
            }
        },
        webAppUserToUpdateEmailEmail: function (newValue) {
            this.webAppUserEmailUpdateForm.email = newValue;
        },
        webAppUserToDelete: function (webAppUser) {
            if(webAppUser !== null) {
                this.webAppUserDeleteDialog = true;
            }
        },
        webAppUserDeleteDialog: function (newValue) {
            if(!newValue) {
                this.webAppUserToDelete = null;
            }
        },
        webAppUserToEmailVerificationAt: function (webAppUser) {
            if(webAppUser !== null) {
                this.webAppUserEmailVerificationAtDialog = true;
            }
        },
    }
}
</script>

<style scoped>

</style>
